import React from 'react';
import ItemListLine from 'src/item-list/components/item-list-line';
import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import EmptyLine from 'src/item-list/components/empty-line';
import { store } from 'src/common/redux/configure-store';
import { ItemCategories } from 'src/common/enumerations/rti-enums/item-categories';
import { LineItemStatus } from 'src/common/enumerations/line-item-status';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';

interface GenerateListProps {
  items: IElectronicJournalRecord[];
  pageSize: number;
  tbrItemsList: IElectronicJournalRecord[];
  isCustomerDisplay?: boolean;
  trainingModeActive?: boolean;
  isTBRActive?: boolean;
  isItems?: boolean;
  isDisabled?: boolean;
}

const GeneratedItemList: React.FC<GenerateListProps> = (props: GenerateListProps): JSX.Element => {
  const {
    items,
    pageSize,
    tbrItemsList,
    isCustomerDisplay,
    trainingModeActive,
    isTBRActive,
    isItems,
    isDisabled,
  } = props;

  const { showTareLinkedItemOnEJ } = getCurrentXLRConfig();

  const itemList = items.flatMap((item, index) => {
    const allowToShowDepositLinkedItems = !!store.getState().touchPoint.touchPointConfiguration
      .depositConfigurations?.displayDepositItemOnCashierDisplayAndCustomerDisplay;
    const itemLine = (
      <ItemListLine
        item={item}
        key={`${item.ItemId}-${index}`}
        showSelectedItem
        isCustomerDisplay={isCustomerDisplay}
        trainingModeActive={trainingModeActive}
        isTBRActive={isTBRActive}
        tbrItemsList={tbrItemsList}
        pageSize={pageSize}
        disabled={
          isDisabled ||
          (isTBRActive &&
            (!item.tbrReturnItem || item.Type === EJRecordTypes.Promotion) &&
            !isCustomerDisplay)
        }
      />
    );
    const linkedItemLines =
      item.LinkedLines?.filter(
        item =>
          (item.ItemType == ItemCategories.Deposit && allowToShowDepositLinkedItems) ||
          (item.ItemType != ItemCategories.Deposit &&
            ((item.ItemType == ItemCategories.Tare && showTareLinkedItemOnEJ) ||
              (item.ItemType !== ItemCategories.Tare && item.Status !== LineItemStatus.Cancelled))),
      )
        .filter(item => item.Amount !== 0)
        .map(linkedItem => (
          <ItemListLine
            item={item}
            key={`${item.ItemId}-linked-${index}`}
            showSelectedItem
            isCustomerDisplay={isCustomerDisplay}
            linkedItem={linkedItem}
            trainingModeActive={trainingModeActive}
            isTBRActive={isTBRActive}
            tbrItemsList={tbrItemsList}
            pageSize={pageSize}
            disabled={isTBRActive && item.Type === EJRecordTypes.Promotion}
          />
        )) ?? [];
    return [itemLine, ...linkedItemLines];
  });
  if (isItems) {
    const emptyListItems = Array.from({ length: pageSize - itemList.length }, (_, i) => (
      <EmptyLine key={`emptyItem-${i}`} pageSize={pageSize} />
    ));

    return (
      <>
        {emptyListItems}
        {itemList}
      </>
    );
  } else {
    return <>{itemList} </>;
  }
};

export default GeneratedItemList;
